import {Injectable} from '@angular/core';
import {VeritiyPricesTableRowModel} from '../../prices-view/models/verity-prices-table-row-model';

@Injectable({
    providedIn: 'root'
})
export class TableColumnsService {
    public tableColumns: Array<VeritiyPricesTableRowModel>;
}
